<template>
  <div class="cmp-distribution-accounts-manual-match-bottom">
    <div class="contact-search">
      <InputField
        :id="'manual-match-bottom_search'"
        :value="searchString"
        :placeholder="$t('search_in_catalog')"
        :config="{
          borderStyle: 'around',
          maxWidth: '330px',
        }"
        @keyup="onSearchInputKeyup"
      >
      </InputField>
    </div>
    <div
      v-if="
        currentChannel === 'physical' ||
        currentChannel === 'digital' ||
        currentChannel === 'thirdparty' ||
        cost_group_target == 'physical' ||
        cost_group_target == 'digital'
      "
      style="margin-top: 20px"
    >
      <h4 style="margin-bottom: 5px" class="ut-text-secondary">
        {{ $t("search_results_for") }}
        {{ currentChannel == "physical" ? $t("products") : $t("playlists") }}
      </h4>
      <table
        style="
          background: var(--body-background);
          border: 1px solid var(--sprt-5);
        "
        class="dt-table2"
      >
        <thead
          class="dt-table2--head"
          style="border-bottom: 1px solid var(--sprt-7)"
        >
          <tr class="dt-table2--row">
            <th class="dt-table2--column">{{ $t("catalog_no") }}</th>

            <th class="dt-table2--column">{{ $t("title") }}</th>

            <th class="dt-table2--column">{{ $t("artist") }}</th>
            <th v-if=" currentChannel === 'physical' || currentChannel === 'digital'" class="dt-table2--column">{{ $t("version") }}</th>
            <th class="dt-table2--column">{{ $t("format") }}</th>

            <th class="dt-table2--column">{{ $t("barcode") }}</th>
          </tr>
        </thead>
        <tbody
          style="border: 0px"
          class="dt-table2--body"
          :style="{
            height: `${
              productList.length > 0
                ? productList.length <= 5
                  ? productList.length * 40
                  : 200
                : 40
            }px`,
          }"
        >
          <tr
            class="dt-table2--row"
            style="margin: 0px"
            v-for="item in productList"
            :key="item.product_id"
          >
            <td class="dt-table2--column">
              <div class="ut-flex">
                <div
                  class="dt-icon-container select-button"
                  @click="onProductRowClicked(item)"
                >
                  <img
                    src="static/icons/arrows/arrow-right-blue.svg"
                    class="dt-icon v5 s2 nohover"
                    alt
                  />
                </div>
                <span>{{ item["catalog_no"] }}</span>
              </div>
            </td>
            <td class="dt-table2--column">
              <span> {{ item["release_title"] }} </span>
            </td>
            <td class="dt-table2--column">
              <span> {{ item["release_artist"] }}</span>
            </td>
            <td v-if=" currentChannel === 'physical' || currentChannel === 'digital'" class="dt-table2--column">
              <span> {{ item["version"] }} </span>
            </td>
            <td class="dt-table2--column">
              <span> {{ item["format_name"] }} </span>
            </td>
            <td style="border-right: 0px" class="dt-table2--column">
              <span> {{ item["barcode"] }} </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      v-if="
        currentChannel === 'performance' ||
        currentChannel === 'digital' ||
        currentChannel === 'thirdparty'
      "
      style="margin-top: 20px"
    >
      <h4 class="ut-text-secondary" style="margin-bottom: 5px">
        {{ $t("search_results_for") }} {{ $t("tracks") }}
      </h4>
      <table
        style="
          background: var(--body-background);
          border: 1px solid var(--sprt-5);
        "
        class="dt-table2"
      >
        <thead
          class="dt-table2--head"
          style="border-bottom: 1px solid var(--sprt-7)"
        >
          <tr class="dt-table2--row">
            <th class="dt-table2--column">{{ $t("ISRC") }}</th>

            <th class="dt-table2--column">
              {{ $t("title") }}
            </th>

            <th class="dt-table2--column">{{ $t("artist") }}</th>
            <th v-if=" currentChannel === 'physical' || currentChannel === 'digital'" class="dt-table2--column">{{ $t("version") }}</th>
            <th class="dt-table2--column">{{ $t("type") }}</th>

            <th class="dt-table2--column">{{ $t("catalog_no") }}</th>
          </tr>
        </thead>
        <tbody
          style="border: 0px"
          class="dt-table2--body"
          :style="{
            height: `${
              trackList.length > 0
                ? trackList.length <= 5
                  ? trackList.length * 40
                  : 200
                : 40
            }px`,
          }"
        >
          <tr
            class="dt-table2--row"
            style="margin: 0px"
            v-for="item in trackList"
            :key="item.track_id"
          >
            <td class="dt-table2--column">
              <div class="ut-flex">
                <div
                  class="dt-icon-container select-button"
                  @click="onRowClicked(item)"
                >
                  <img
                    src="static/icons/arrows/arrow-right-blue.svg"
                    class="dt-icon v5 s2 nohover"
                    alt
                  />
                </div>
                <span>{{ item["isrc"] }}</span>
              </div>
            </td>
            <td class="dt-table2--column">
              <span>{{ item["title"] }}</span>
            </td>
            <td class="dt-table2--column">
              <span> {{ item["artist"] }} </span>
            </td>
            <td v-if=" currentChannel === 'physical' || currentChannel === 'digital'" class="dt-table2--column">
              <span> {{ item["version"] }} </span>
            </td>
            <td class="dt-table2--column">
              <span> {{ item["type"] }} </span>
            </td>
            <td style="border-right: 0px" class="dt-table2--column">
              <span>{{ item["catalog_no"] }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="cost_group_target == 'release'" style="margin-top: 20px">
      <h4 style="margin-bottom: 5px">
        {{ $t("search_results_for") }} {{ $t("releases") }}
      </h4>
      <table
        style="
          background: var(--body-background);
          border: 1px solid var(--sprt-5);
        "
        class="dt-table2"
      >
        <thead
          class="dt-table2--head"
          style="border-bottom: 1px solid var(--sprt-7)"
        >
          <tr class="dt-table2--row">
            <th class="dt-table2--column">{{ $t("Identifier") }}</th>

            <th class="dt-table2--column">{{ $t("artist") }}</th>

            <th class="dt-table2--column">{{ $t("title") }}</th>

            <th class="dt-table2--column">{{ $t("label") }}</th>
          </tr>
        </thead>
        <tbody
          style="border: 0px"
          class="dt-table2--body"
          :style="{
            height: `${
              releaseList.length > 0
                ? releaseList.length <= 5
                  ? releaseList.length * 40
                  : 200
                : 40
            }px`,
          }"
        >
          <tr
            class="dt-table2--row"
            style="margin: 0px"
            v-for="item in releaseList"
            :key="item.release_id"
          >
            <td class="dt-table2--column">
              <div class="ut-flex">
                <div
                  class="dt-icon-container select-button"
                  @click="onReleaseRowClicked(item)"
                >
                  <img
                    src="static/icons/arrows/arrow-right-blue.svg"
                    class="dt-icon v5 s2 nohover"
                    alt
                  />
                </div>
                <span> {{ item["identifier"] }} </span>
              </div>
            </td>
            <td class="dt-table2--column">
              <span> {{ item["release_artist"] }} </span>
            </td>
            <td class="dt-table2--column">
              <span> {{ item["release_title"] }} </span>
            </td>
            <td class="dt-table2--column">
              <span> {{ item["label_name"] }} </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";

import InputField from "@plugins/text-field/input-field";
import { DistributionStatementService } from "../../services/statement.service";
import { Subject } from "rxjs";
import { subscribeSubject } from "../../../../utility";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
export default {
  components: {
    NTable,
    InputField,
    DTIconButton,
    //AdvanceSearch,
  },
  props: {
    modalData: {
      type: Object,
    },
    searchStringValue: {
      type: String,
    },
    currentChannel: {
      type: String,
    },
  },
  data: function () {
    return {
      searchResult: {},
      trackSubject$: new Subject(),
      trackSearchResult: [],
      tracks: [],
      searchString: "",
    };
  },
  mounted: function () {},

  mixins: [],
  watch: {
    searchStringValue: {
      immediate: true,
      handler: function (newVal, oldVal) {
        if (newVal) {
          console.log("newVal", newVal);
          this.searchString = newVal || "";
        }
      },
    },
  },
  computed: {
    statement_line_id: function () {
      return this.$route?.query?.statement_line_id || "";
    },

    statementLine: function () {
      return this.modalData?.stmt_line || {};
    },

    cost_group_target: function () {
      return this.modalData?.cost_group?.target || null;
    },
    trackList: function () {
      return this.modalData?.tracks || [];
    },
    productList: function () {
      return this.modalData?.products || [];
    },
    releaseList: function () {
      return this.modalData?.releases || [];
    },
  },
  methods: {
    onCancelClick: function () {
      this.$emit("cancelled", true);
    },
    onSearchInputKeyup: function (e) {
      this.searchString = e.target.value;
      this.$emit("searchString", this.searchString);
    },
    onRowClicked: function (item) {
      this.$emit("trackClick", item);
    },
    onReleaseRowClicked: function (item) {
      this.$emit("releaseClick", item);
    },
    onProductRowClicked: function (item) {
      this.$emit("productClick", item);
    },
  },
};
</script>

<style lang="scss">
.cmp-distribution-accounts-manual-match-bottom {
  .dt-table2 {
    --body-height: inherit;
    --row-height: auto;
    border-collapse: collapse;
  }
  thead {
    .dt-table2--row {
      height: 30px;
      margin: 0px !important;
      padding: 0px;
      .dt-table2--column {
        margin-left: 10px;
      }
    }
  }
  tbody {
    
    // It is still on the global style. But this is not needed here anymore based on this trello card 
    // https://trello.com/c/tgdm3PJ1/133-distribution-import-import-matching-manual-matches-modal
    // https://trello.com/1/cards/615ca2f53bc07f4e6fc98287/attachments/65b7cf7ac9010c830cfe7b53/download/manual_matches_modal_correction.png please adjust the row height for the `Playlist`and `Tracks` box.
  
    padding-bottom: 0px;

    .dt-table2--row {
      //margin: var(--row-margin-header) !important;
      padding: var(--row-padding);
      height: 40px;
      min-height: 40px !important;
      .dt-table2--column {
        .select-button {
          border: 1px solid var(--silver);
          margin-right: 20px;
          border-radius: 4px;

          background: var(--emerald-a10);

          &:hover {
          }
        }

        border-right: 1px solid var(--sprt-7);
        margin-left: 10px;
        padding: 5px 0px;
        cursor: pointer;
        white-space: break-spaces;
        //overflow-wrap: break-word;
        word-wrap: break-word; /* All browsers since IE 5.5+ */
        overflow-wrap: break-word;
      }

      &:hover {
        background: var(--emerald-a10);
      }
    }
  }
}
</style>